import React, { useState } from "react";
import Select from "react-select";
import { parseCommissionRate, defaultCommissionRate, PAYOUT_TYPES } from "./shootSalesModel";

const descriptions={
  standard:"Commission on every shoot, with a $40 minimum, plus mileage.",
  salaryWeekend:"Weekdays: mileage only. Saturday/Sunday: commission with a $40 minimum, plus mileage.",
  weekend:"Weekdays: $0. Saturday/Sunday: commission with a $250 minimum. No mileage on any day.",
};
export default function CommissionSettings({nicknames,rates,onSave,disabled}) {
  const [selected,setSelected]=useState("");
  const [drafts,setDrafts]=useState({});
  const [saving,setSaving]=useState(false);
  const [error,setError]=useState("");
  const name=nicknames.includes(selected) ? selected : nicknames[0] || "";
  const savedType=rates[name]?.payoutType || "standard";
  const original={commissionRate:defaultCommissionRate(rates,name) ?? "",payoutType:savedType==="salary" ? "salaryWeekend" : savedType};
  const values=drafts[name] || original;
  const changed=Object.keys(drafts);
  const change=patch=>{setDrafts(current=>({...current,[name]:{...values,...patch}}));setError("");};
  return <details className="shoot-sales-rates"><summary>Photographer rates & payout types</summary>
    <p className="shoot-sales-help">Choose a photographer to edit their defaults. Saved shoots keep their existing settings. Extra pay is entered on each shoot.</p>
    <form onSubmit={async event=>{
      event.preventDefault();setError("");
      try {
        const updates={...rates};
        changed.forEach(person=>{
          const draft=drafts[person];
          if(!Object.prototype.hasOwnProperty.call(descriptions,draft.payoutType))throw new Error("Choose a valid payout type.");
          updates[person]={commissionRate:parseCommissionRate(draft.commissionRate),payoutType:draft.payoutType};
        });
        setSaving(true);await onSave(updates);setDrafts({});
      }catch(failure){setError(failure.message || "Could not save settings.");}finally{setSaving(false);}
    }}><fieldset disabled={saving || disabled || !name}><legend>Photographer settings</legend>
      <label htmlFor="commission-photographer">Photographer</label>
      <Select inputId="commission-photographer" isDisabled={saving || disabled || !name} options={nicknames.map(person=>({value:person,label:person+(drafts[person] ? " (unsaved)" : "")}))} value={name ? {value:name,label:name} : null} onChange={option=>{setSelected(option?.value || "");setError("");}} placeholder="Search photographers..." />
      <div className="shoot-sales-settings-fields">
        <label>Commission (%)<input type="number" min="11" max="30" step="0.01" value={values.commissionRate} placeholder="Not set" onChange={event=>change({commissionRate:event.target.value})} /></label>
        <label>Payout type<select value={values.payoutType} onChange={event=>change({payoutType:event.target.value})}>{Object.keys(descriptions).map(type=><option key={type} value={type}>{PAYOUT_TYPES[type]}</option>)}</select></label>
      </div>
      <p className="shoot-sales-policy-description">{descriptions[values.payoutType]}</p>
      <div className="shoot-sales-actions"><button type="submit" disabled={!changed.length}>{saving ? "Saving..." : `Save settings${changed.length>1 ? ` (${changed.length} photographers)` : ""}`}</button><button type="button" disabled={!changed.length} onClick={()=>{setDrafts({});setError("");}}>Discard changes</button></div>
      {changed.length>0 && <p className="shoot-sales-help">Unsaved: {changed.join(", ")}. Switching photographers keeps these drafts until you save or discard.</p>}
    </fieldset>{!name && <p>No photographers found.</p>}{error && <p role="alert">{error}</p>}</form>
  </details>;
}
